<!--
 * @Description:联系人
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-11-07 17:04:26
 * @LastEditors: cxh
-->
<template>
  <cos-table v-bind="$attrs" :columns="columns" @fetch="fetch" ref="table">
    <template #bodyCell="{ column, record }">
      <template v-if="column.dataIndex === 'action'">
        <a-button type="link" @click="handleEdit(record)" :disabled="permissionPage?.isPublic" v-permission="permissionPage?.edit"> 编辑 </a-button>
        <a-button type="link" @click="handleDelete(record)" :disabled="permissionPage?.isPublic" v-permission="permissionPage?.del"> 删除 </a-button>
      </template>
    </template>
  </cos-table>
  <EditModal ref="editModalRef" @success="refresh" />
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import EditModal from './editModal.vue'
import dataConfig from '@/views/gucangSales/commonEnum/dataConfig'
import { customerContactList, customerContactDelete } from '@/api/gucangSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { listByParamCodes } from '@/api/common'
import { bool } from 'vue-types'
const table = ref()
const editModalRef = ref()
const loading = ref(false)
const paramCodeData = ref<{
  fbu_area_code: []
}>({
  fbu_area_code: [] // 电话区号
})
const props = defineProps({
  disabled: {
    type: Boolean,
    default: true
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  contactRefId: {
    type: String
  },
  hideOk: {
    type: Boolean
  }
})
const fetch = (params: object, callBack: (res: any) => void) => {
  if (props.contactRefId) {
    customerContactList({
      contactRefId: props.contactRefId,
      ...params
    }).then((res) => {
      callBack(res)
    })
  }
}
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_area_code']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const refresh = (type?: 'add' | 'edit') => {
  if (type === 'edit') {
    table.value.fetch()
  } else {
    table.value.search()
  }
}
// 新增
// const handleAdd = () => {
//   editModalRef.value.toggle()
// }
// 编辑
const handleEdit = (row: PotentialItem['contact']) => {
  editModalRef.value.toggle(row)
}
// 删除
const handleDelete = (row: PotentialItem['contact']) => {
  Modal.delete({
    name: row.name,
    onOk() {
      loading.value = true
      customerContactDelete({
        id: row.id,
        contactRefId: row.contactRefId
      })
        .then((res) => {
          table.value.delFetch()
          message.success('删除成功')
        })
        .finally(() => {
          loading.value = false
        })
    }
  })
}
const columns = computed(() => {
  const init: any = [
    {
      title: '联系人类型',
      dataIndex: 'contactType',
      dicData: dataConfig.contactTypeEnum
    },
    {
      title: '联系人名称',
      dataIndex: 'name'
    },
    {
      title: '手机号',
      dataIndex: 'mobile'
    },
    {
      title: '微信号',
      dataIndex: 'wechat'
    },
    {
      title: 'QQ号',
      dataIndex: 'qq'
    },
    {
      title: '邮箱',
      dataIndex: 'email'
    },
    {
      title: '固定电话',
      dataIndex: 'tel'
    },
    {
      title: '角色',
      dataIndex: 'jobRole',
      dicData: dataConfig.linkRoleTypeEnum
    },
    {
      title: '性别',
      dataIndex: 'sex',
      dicData: dataConfig.genderEnum
    },
    {
      title: '部门职务',
      dataIndex: 'jobDuty'
    },
    {
      title: '传真号',
      dataIndex: 'fax'
    }
  ]
  if (!props.hideOk) {
    init.push({
      title: '操作',
      fixed: 'right',
      width: 120,
      dataIndex: 'action'
    })
  }
  return init
})
defineExpose({
  refresh
})
</script>
<script lang="ts">
export default {
  name: 'ContactsTable'
}
</script>
